import { ReactNode, useState } from 'react';
import { AsideBar, Loader } from '../../../components';
import styles from './Layout.module.scss';
import cn from 'classnames';

const Layout = ({
  children,
  title,
  logOut,
  loading = false,
}: {
  children: JSX.Element;
  title?: ReactNode;
  logOut: () => void;
  loading?: boolean;
}) => {
  const [isOpenMenu, setOpenMenu] = useState(false);

  const toggleMenu = () => setOpenMenu(prev => !prev);

  return (
    <div className={styles.layoutContainer}>
      <AsideBar isOpenMenu={isOpenMenu} logOut={logOut} />
      <div className={styles.layoutContainer__content}>
        <div className={styles.layoutContainer__inner}>
          <h1 className={styles.layoutContainer__title}>
            {title} {loading && <Loader size={40} />}
          </h1>
          <div
            className={cn(styles.layoutContainer__burger, {
              [styles.layoutContainer__burger_isActive]: isOpenMenu,
            })}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {children}
      </div>
    </div>
  );
};

export default Layout;
